import React, { Fragment, useState, useEffect, useMemo } from 'react';
import ReactDOM from 'react-dom';
import useStyle from '../../hooks/useStyle';
import { useHistory } from "react-router-dom";
import SubscriptionAccessesService from '../Subscriptions/SubscriptionAccessesService';
import CheckAccess from './CheckAccess';
import { DataSourcePermissionKey } from '../../constants/DataSourceList';
import FavouriteService from '../../services/FavouritesService';
import RoleService from '../Roles/RoleService.js';
import { useCurrentUserHook } from '../Authentication/useUserHook.js';
import { Spinner } from '../Common/Spinner.js';
import { CheckBox2 } from "../Common/FormInput";

const subPermissionMap = {
  'read':'Read',
  'write':'Write',
  'csv_download':'Csv Download', 
  'filters': 'Filters',
  'delete': 'Delete',
  'charts': 'Charts',
  'form_test_inputs': {
    'verify':'Verify Input Form Submit'
  }, 
  'user_reg_request': {
    'verify': 'Verify User Registration',
    'add_to_org_member': 'Issue account'
  },
  'case_list':{
    'upcoming_schedules': 'Upcoming Schedule Popup',
    'batch_delete': 'Batch Delete'
  },
  'feedback':{
    'reset_otp': 'OTP Reset'
  },
  'infant_process':{
    'read_only_editable': 'Edit Read Only Field',
    'review': 'Review'
  },
  'training':{
    'add_to_org_member': 'Issue account'
  }
}

const UserAccessComponents = (props) => {
  const {isOpen, toggleModal, subscription, isPopupMode} = props;
  useStyle("filter_dialog");
  
  const history = useHistory();
  
  const {currentUser} = useCurrentUserHook();

  const [components, setComponents] = useState({});
  const [favourites, setFavourites] = useState({});
  const [role, setRole] = useState();
  const [loading, setLoading] = useState(true);
  const [index, setIndex] = useState(null);
  const [orgMember, setOrgmember] = useState(props.orgMember);

  useEffect(() => {
    getUserAccess();
  }, [])

  const getUserAccess = async ()=>{
    setLoading(true);
    await getSubscriptionAccess();
    await getRole();
    setLoading(false);
  }

  /*useEffect(() => {
    SubscriptionAccessesService.getAll({
      "subscription_id": currentUser.current_subscription?.id,
      "role_ids": currentMember.role_record_id,
      "favourite_params":{
        "favorable_type": "journey_component"
      }
    }).then(({status, data})=>{
      if(status == 200){
        //setComponents(data.journey_components)
        setRolesDescription(data.roles?.join('\n'))
        setFavourites(data.favourites)
        //setIndex(Object.keys(data.journey_components)?.length - 1)
        setLoading(false)
      }
    })
  }, [])*/  

  const getSubscriptionAccess = async () =>{
    if(subscription){
      const {status, data} = await SubscriptionAccessesService.get(
        subscription.id, 
        {'locale':currentUser.current_locale}
      );
      if(status === 200){
        setComponents(data);
      }
    }
  }

  const getRole = async () =>{
    if(orgMember.permissions){
      setRole({role: orgMember.role_names});
    }else if(orgMember.role_id){
      const {status, data} = await RoleService.get(orgMember.role_id);
      if(status === 200){
        setOrgmember({...orgMember, permissions: data.permissions});
        setRole(data);
      }
    }
  }

  const addOrRemoveFavourite = (component, favourite) =>{
    setLoading(true);
    if(favourite?.id){
      FavouriteService.delete(favourite.id).then(({status, data})=>{
        if(status == 204)
          favourites[component.pk_id] = null;
          setLoading(false);
      })
    }else{
      const req = {
        'favorable_type':'journey_component', 
        'favorable_id':component.pk_id, 
      }
      FavouriteService.create(req).then(({status, data})=>{
        if(status == 201)
          favourites[component.pk_id] = data.favourite;
          setLoading(false);
      })
    }
  }

  const Favourite = ({component}) =>{
    const isFav = favourites[component.pk_id]?'fas fa-star':'far fa-star';
    return <i onClick={() => addOrRemoveFavourite(component, favourites[component.pk_id])} className={`${isFav} black pull-right`}/>;
  }

  const SubPermission = ({subPermissionkey, subPermissions}) => {
    if(typeof subPermissions === 'object'){
      return(
        <div className="m-l-25 black-light-1">
          {Object.keys(subPermissions).map((o, k) =>
            <span key={k} className="m-l-15 underline">
              {subPermissionMap[o] || subPermissionMap[subPermissionkey]?.[o]}
            </span>
          )}
        </div>
      )
    }

    return null;
  }

  const Components = ({list=[], permissions, dataSourceKey}) =>{
    return(
      <div className="popup-menu-grid br-grey" id={`dsl_${dataSourceKey}`}>
        {list.map((o, k) =>
          <div className="ver-icons" key={k}>
            <span><i className={o.icon || "fas fa-plus"} style={{ color: o.icon_color }}/></span>
            <div className="popup-menu-title">{o.label}</div>
            <Favourite component={o}/>
            <div className="m-l-40 black-light-1">{o.description || o.detail}</div>
            <SubPermission subPermissionkey={o.sid} subPermissions={permissions[o.sid]}/>
          </div>
        )}
      </div>
    )
  }

  const Component = ({o, k}) => {
    const color = components[o]?.settings?.bg_color || '#5E5E5E';
    const style = {borderLeft: `6px solid ${color}`};
    const permissionKey = DataSourcePermissionKey[components[o].id];
    const permissions = orgMember?.permissions?.[permissionKey];

    const accessList = useMemo(() => 
      components[o]?.options?.filter(o => CheckAccess.checkUserAccess(orgMember, permissions, o.sid)), []
    )

    if(accessList.length === 0) return null;
    
    return(
      <>
        <div className="flex justspacebetween aligncenter black p-6 font-15 br-grey m-b-10 m-t-10 bg-lightgrey1"  
          id={`ds_${o}`} onClick={e=> index === k ? setIndex(null) : setIndex(k)} style={style}>
            {components[o].label}
            <i className={`fas ${index === k ? 'fa-chevron-up' : 'fa-chevron-down'} black pull-right m-r-10`} onClick={()=>setIndex(index === k?null:k)}/>
        </div>
            
        {(index === k || index === "5") && <Components list={accessList} permissions={permissions} dataSourceKey={o}/>}
      </>
    )
  }

  const ComponentList = () => Object.keys(components).map((o, k) =>
    <Component o={o} key={k} k={k}/>  
  )
  
  const UserAccessComponents = () =>{
    return(
      <>
        {loading ?
          <Spinner/>
          :
          <div className={`p-10 ${isPopupMode ? 'scroll-x vh-90' : ''}`}>
            <div className="flex justspacebetween aligncenter">
              {role &&
                <h2 className="m-b-20">
                  {role.role}
                </h2>
              }
              <CheckBox2
                label="View all"
                toggle={() => index === "5" ? setIndex(null) : setIndex("5")}
                exists={() => index === "5"}
                name="read">
              </CheckBox2>
            </div>
            <ComponentList/>
          </div>
        }
      </>
    )
  }

  if(isPopupMode){
    return(
      ReactDOM.createPortal(
        <>
          <div className="ml-modal">
            <div className="ml-modal-content ml-card-4 ml-animate-zoom brd-10">
              
              <div className="flex justspacebetween modal-title">
                <h4 className="f18 text-white fw500 p12-10-15">Services available to access</h4>
                <button className="btn-close" title="Close Modal" onClick={e => toggleModal(e)}>
                  ×
                </button>
              </div>
              
              <UserAccessComponents/>
                
            </div>
          </div>
        </>, document.body
      )
    )
  }

  return <UserAccessComponents/>

}

export default UserAccessComponents;